module.exports = __webpack_public_path__ + "img/vote_high.4df68426.svg";